import { removePlateForm, removeToken, removeFunc } from '@/utils/auth';
import store from '../store/index';

export function clearAll() {
  removeToken();
  removePlateForm();
  removeFunc();
  store.commit('app/CLEAR_PERMISSION_CODES');
  store.commit('app/CLEAR_USER_DATA');
  store.commit('app/CLEAR_MENUS_ALISA');
  store.commit('app/CLEAR_TABLE_FILTER');

  localFun.remove('enterpriseLogo');
  localFun.remove('enterpriseName');
  localFun.remove('enterpriseId');
  localFun.remove('plateForm');
  localFun.remove('mobile');
  localFun.remove('menu-role');
  localFun.remove('autoReportSwitch');
  localFun.remove('externalAutoReportSwitch');
  localFun.remove('mode');
  localFun.remove('isNewVersion');
  localFun.remove('sidebarStatus');

  localFun.remove('userInfo');
  localFun.remove('watermarkConfigSelected');

  localFun.remove('tempSessionId');
  localFun.remove('deptId');
  localFun.remove('representativeUid');
}
